import { useWebSocketChat } from './useWebSocketChat';
import { useAuth } from '../contexts/AuthContext';
import { useBusiness } from '../contexts/BusinessContext';

interface UseAgentToClientChatOptions {
  clientEmail: string;
  autoConnect?: boolean;
}

export function useAgentToClientChat({ clientEmail, autoConnect }: UseAgentToClientChatOptions) {
  const { user, isAuthenticated } = useAuth();
  const { business } = useBusiness();

  return useWebSocketChat({
    autoConnect,
    buildUrl: () => {
      if (!isAuthenticated || !user?.email || !business?.id || !clientEmail) return null;
      const encodedAgent = encodeURIComponent(user.email);
      const encodedClient = encodeURIComponent(clientEmail);
      return new URL(
        `/api/business/${business.id}/${encodedAgent}/client/${encodedClient}/chat`,
        window.location.origin
      ).toString().replace(/^http/, 'ws');
    },
    currentUser: {
      id: user?.id,
      name: user?.name ?? 'Agent',
      email: user?.email,
      role: 'agent'
    },
    // ↓ supply at least a fallback identity for the client
    otherUser: {
      name: clientEmail || 'Client',
      email: clientEmail,
      role: 'client'
    }
  });
}
